function validIncludeDirective($compile) {
    'ngInject';

    return {
        link(scope, element, attr) {
            scope[attr.watchValue].then((logged) => {
                element.attr('ng-include', attr.ngValidInclude);
                element.attr('ng-valid-include', null);
                $compile(element)(scope);
            });
        }
    };
}

angular
    .module('BB')
    .directive('ngValidInclude', validIncludeDirective);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/valid-include/ng_valid_include.directive.js